import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdvanceSalary,
  setAdvanceSalaryPage,
} from "../../../actions/advanceSalary";
import Pagination from "../../../components/library/pagination";
import { AdvanceSalaryStatus } from "../../../dto";
import { ReactComponent as Loader } from "../../../images/loader.svg";
import dispatch from "../../../middleware";
import { AdvanceSalaryDetails } from "../../../models";
import { ReduxState } from "../../../reducers";
import { getMonthTypeInputValueFromDate } from "../../../utils";
import getEffect from "../effect";
import AdvanceSalaryFilters from "./advanceSalaryFilters";
import AdvanceSalaryTable from "./advanceSalaryTable";
import { AdvanceSalarySearchContext } from "./utils";

export default function AdvanceSalary() {
  const storeDispatch = useDispatch();
  const loading = useSelector(
    (state: ReduxState) => state.advanceSalary.loading,
  );
  const advanceSalaries: AdvanceSalaryDetails = useSelector(
    (state: ReduxState) => state.advanceSalary.advanceSalaries,
  );
  const { page, pageSize, totalPages } = useSelector(
    (state: ReduxState) => state.advanceSalary.paginationData,
  );

  const [selectedAdvanceSalaryStatus, setSelectedAdvanceSalaryStatus] =
    useState<AdvanceSalaryStatus>(AdvanceSalaryStatus.ACTIVE);
  const [selectedMonthAndYear, setSelectedMonthAndYear] = useState<Date | null>(
    new Date(),
  );

  const fetchAdvanceSalaries = useCallback(async () => {
    const monthAndYear = getMonthTypeInputValueFromDate(selectedMonthAndYear);
    if (!monthAndYear) return;
    const [year, month] = monthAndYear.split("-");

    try {
      const payload: AdvanceSalarySearchContext = {
        month: Number(month),
        year: Number(year),
        status: selectedAdvanceSalaryStatus,
        pageNo: page,
        pageSize,
      };
      await dispatch(storeDispatch, getAdvanceSalary(payload));
    } catch (e) {
      console.log(e);
    }
  }, [
    selectedMonthAndYear,
    selectedAdvanceSalaryStatus,
    page,
    pageSize,
    storeDispatch,
  ]);

  useEffect(() => {
    return getEffect("Salary Topup", storeDispatch)();
  }, [storeDispatch]);

  useEffect(() => {
    fetchAdvanceSalaries();
  }, [fetchAdvanceSalaries]);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <AdvanceSalaryFilters
        selectedStatus={selectedAdvanceSalaryStatus}
        selectedDate={selectedMonthAndYear}
        onDateChange={(e) =>
          setSelectedMonthAndYear(e.currentTarget.valueAsDate)
        }
        onSelectChange={(_, value) => {
          setSelectedAdvanceSalaryStatus(String(value) as AdvanceSalaryStatus);
        }}
      />
      <div className="mt-4">
        <AdvanceSalaryTable
          selectedStatus={selectedAdvanceSalaryStatus}
          advanceSalaries={advanceSalaries}
        />
      </div>
      <Pagination
        currentPage={page}
        totalPageCount={totalPages}
        onChange={(newPage) =>
          dispatch(storeDispatch, setAdvanceSalaryPage(newPage))
        }
        terminalNeighbourCount={1}
        neighbourCount={1}
        jumpToLabel="Go to"
      />
    </>
  );
}
